// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"editor-sliding-panel__wrapper___1Srnm","button":"editor-sliding-panel__button___1wNcj","icon":"editor-sliding-panel__icon___22Dzq","text":"editor-sliding-panel__text___39js-","opened":"editor-sliding-panel__opened___3mp12"};
    if(module.hot) {
      // 1680115563735
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  